<script>
export default {
    name: "ArrowRight"
}
</script>
<template>
    <svg role="img" aria-label="Arrow Right"  width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.8785 10.0745L22 9L20.8834 7.92552L13.7691 1.07924L12.6477 0L10.4146 2.15372L11.5311 3.22821L15.9479 7.47861L1.58096 7.47861H0L0 10.5214H1.58096L15.943 10.5214L11.5262 14.7718L10.4146 15.8463L12.6477 18L13.7642 16.9255L20.8785 10.0792V10.0745Z" fill="white"/>
    </svg>
</template>
